import { QueryClient, QueryClientProvider } from 'react-query';
import { ReactQueryDevtools } from 'react-query/devtools';
import { MsalProvider } from '@azure/msal-react';
import { getDynamicComponents } from 'components';
import AvisCookies from 'components/corporatiu/AvisCookies';
import Modal from 'components/corporatiu/Modal';
import ErrorBoundary from 'components/corporatiu/ErrorBoundary';
import Loading from 'components/corporatiu/Loading';
import ServicesListener from 'components/ServicesListener';
import PublicitatProvider from 'context/PublicitatProvider';
import ContentUserProvider from 'context/corporatiu/ContentUserProvider';
import GlobalVarsProvider from 'context/GlobalVarsProvider';
import HistoryProvider from 'context/corporatiu/HistoryProvider';
import LoadingProvider from 'context/corporatiu/LoadingProvider';
import ModalProvider from 'context/corporatiu/ModalProvider';
import ServicesProvider from 'context/ServicesProvider';
import UserDelivertyProvider from 'context/UserDelivertyProvider';
import { UserProvider, myMSALObj } from 'context/UserProvider';
import ViewportProvider from 'context/corporatiu/ViewportProvider';
import { useEffect } from 'react';
import styles from '../../../web/styles/corporatiu/globals.module.scss';

const AppCorporatiu = ({ Component, pageProps }) => {
    const queryClient = new QueryClient();
    const DynamicComponents = getDynamicComponents('corporatiu');

    useEffect(() => {
        const initializeMsal = async () => {
            try {
                await myMSALObj.initialize();
            } catch (error) {
                console.error('Error initializing 3cat MSAL:', error);
            }
        };

        initializeMsal();
    }, []);

    return (
        <ErrorBoundary>
            <GlobalVarsProvider>
                <QueryClientProvider client={queryClient}>
                    <HistoryProvider>
                        <MsalProvider instance={myMSALObj}>
                            <LoadingProvider>
                                <ServicesProvider>
                                    <UserProvider>
                                        <UserDelivertyProvider>
                                            <ContentUserProvider>
                                                <ViewportProvider {...pageProps}>
                                                    <PublicitatProvider>
                                                        <ModalProvider>
                                                            <AvisCookies {...pageProps} />
                                                            <div id='__mainContent' className={styles.corporatiu}>
                                                                <ServicesListener {...pageProps} />
                                                                <Component {...pageProps} dynamicComponents={DynamicComponents} />
                                                                <Loading />
                                                                <Modal {...pageProps} />
                                                            </div>
                                                            <div id='app-modal' className={styles.corporatiu} />
                                                            {process.env.isDev && <ReactQueryDevtools initialIsOpen={false} />}
                                                        </ModalProvider>
                                                    </PublicitatProvider>
                                                </ViewportProvider>
                                            </ContentUserProvider>
                                        </UserDelivertyProvider>
                                    </UserProvider>
                                </ServicesProvider>
                            </LoadingProvider>
                        </MsalProvider>
                    </HistoryProvider>
                </QueryClientProvider>
            </GlobalVarsProvider>
        </ErrorBoundary>
    );
};

export default AppCorporatiu;
